import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.patient-medical-information': {
         areYouSureYouWantToMarkAsRemoved: 'Czy na pewno chcesz oznaczyć wpis w danych medycznych jako usunięty?',
         close: 'Zamknij',
         markAsRemoved: 'Oznacz jako usunięty',
         medicalInformationHasBeenRemoved: 'Wpis w danych medycznych został usunięty.',
         other: 'Inny',
         reasonForRemoval: 'Powód usunięcia',
         reasonMap: {
            MISTAKE: 'Omyłkowo dodany wpis',
            OTHER: 'Inny',
         },
         removingMedicalInformation: 'Usuwasz wpis z danych medycznych',
         specifyTheReasonForRemoval: 'Doprecyzuj powód usunięcia...',
         youCannotRemoveAnEntryBecauseItHasBeenSentToP1:
            'Ten wpis w danych medycznych pacjenta został już wysłany do systemu gromadzenia informacji o zdarzeniach medycznych (P1) i nie może zostać usunięty.',
         youCannotRemoveAnEntryBecauseItIsRelatedToAVisit:
            'Ten wpis w danych medycznych pacjenta jest powiązany z wizytą i nie może zostać usunięty.',
         youCannotRemoveAnEntryInTheDocumentation: 'Nie można usunąć wpisu w dokumentacji',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(
   translations.pl,
   '~libs.desktop.patient-medical-information'
);
